import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['states'];

  toggleStates(e) {
    const value = e.target.value;

    this.statesTarget.disabled = value === 'other';
  }
}
